module.exports = "/_next/static/images/happy-monotone-658726dab5576dd43f83d62fcc95632b.svg";